module.exports = __webpack_public_path__ + "static/media/tour2.66aa9433.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/america-off-balance/tour2.jpg
// module id = 297
// module chunks = 0